import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth.service';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { getLocalTranslate } from 'src/app/helpers/global-functions';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-course',
  templateUrl: './course.component.html',
  styleUrls: ['./course.component.css']
})
export class CourseComponent implements OnInit {

  public htmlContent: string;

  public showSpinner: boolean;

  isActiveBuying: boolean = false;

  course: Course = new Course();

  relatedCourses: Course[] = [];

  sampleVideoUrl: SafeUrl;

  home: string = 'Home';
  coursesText: string = 'English Courses';
  courseDetail: string = 'Course Detail';
  relateCourseText: string = 'Related Courses';

  constructor(
    private route: ActivatedRoute,
    private courseService: CourseService,
    private sanizer: DomSanitizer,
    private authService: AuthService,
    private router: Router,
    private firestore: AngularFirestore,
    private seoService: SeoService
  ) {}

  ngOnInit() {

    this.needTranslate();

    this.sampleVideoUrl =
      this.sanizer.bypassSecurityTrustResourceUrl('');

    this.getCourse();

    this.getRealatedCourses();

    this.checkActivateBuyingCourse();
  }

  needTranslate() {

    this.home =
      getLocalTranslate(
        'home',
        this.home
      );

    this.coursesText =
      getLocalTranslate(
        'courses',
        this.coursesText
      );

    this.courseDetail =
      getLocalTranslate(
        'course-detail',
        this.courseDetail
      );

    this.relateCourseText =
      getLocalTranslate(
        'related-courses',
        this.relateCourseText
      );
  }

  getCourse() {

    const id =
      this.route.snapshot.params['id'];

    this.showSpinner = true;

    const id$ =
      new Subject<string>();

    const queryObservable =
      id$.pipe(
        switchMap(id =>
          this.firestore
            .collection('courses')
            .doc(id)
            .get()
        )
      );

    queryObservable.subscribe(
      queriedItem => {

        if (!queriedItem.exists) {

          this.showSpinner = false;

          return;
        }

        const course: Course =
          new Course();

        course.id =
          queriedItem.id;

        Object.assign(
          course,
          queriedItem.data()
        );

        this.course =
          course;

        this.htmlContent =
          this.course.description;

        // ==========================================
        // YouTube
        // ==========================================

        const url =
          'https://www.youtube.com/embed/' +
          this.course.youtubeId;

        this.sampleVideoUrl =
          this.sanizer
            .bypassSecurityTrustResourceUrl(url);

        // ==========================================
        // SEO
        // ==========================================

        const courseName =
          this.course.nameEn ||
          'English Course';

        const description =
          this.course.description ||
          'Learn English with CamEdu.';
        
        const image = this.course.image && this.course.image?.fileUrl ? this.course.image?.fileUrl
            : 'https://camedu-learning.com/assets/images/default-course.jpg';
            
        const pageUrl =
          'https://camedu-learning.com/course/' +
          this.course.id;

        this.seoService.setCourseSeo(
          courseName + ' | CamEdu',
          description,
          image,
          pageUrl
        );

        // ==========================================

        this.showSpinner = false;
      }
    );

    id$.next(id);
  }

  getRealatedCourses() {

    const id: string =
      this.route.snapshot.params['id'];

    const limit = 3;

    this.courseService
      .findAll(limit)
      .then(courses => {

        courses =
          courses.filter(
            course => course.id !== id
          );

        if (courses.length == limit) {

          courses.splice(
            limit - 1,
            1
          );
        }

        this.relatedCourses =
          courses;
      });
  }

  checkActivateBuyingCourse() {

    const id: string =
      this.route.snapshot.params['id'];

    this.courseService
      .checkAllowBuyingCourse(id)
      .then(result => {

        if (result.allow) {

          this.courseService
            .checkDuplicatebuyingCourse(id)
            .then(result => {

              this.isActiveBuying =
                !result.duplicated;

            });
        }
      });
  }

  // Buy
  async buyCourse() {

    this.router.navigate([
      'checkout/' + this.course.id
    ]);
  }

  routeToCourseDetail(id: string) {

    const url =
      '/course/' + id;

    window.location.href =
      url;
  }

  getCourseLength(days: number): string {

    if (days > 30) {

      const month: number =
        days / 30;

      const prefix =
        days % 30;

      if (month === 1) {

        return '1 month';
      }

      if (prefix != 0) {

        return month.toFixed(2) +
          ' months';
      }

      return month +
        ' months';
    }

    return days +
      ' days';
  }
}